import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { H3, Text } from 'components';
import TipCalculatorSiteSelector from 'components/SiteSelector/TipCalculatorSiteSelector';
import { appConfig } from 'config/app';
import { selectIsLoadingAPIRequest } from 'store/ApiClient';
import { DaySegments, getDaySegmentsRequest, selectDaySegments } from 'store/Collections/DaySegments';
import { selectCurrentEmployeeSite } from 'store/Employers';
import { IStore } from 'store/types';
import { SectionTitle, SettingsContent, SettingsContentLayout, SettingsPageHeader, SettingsSection, SettingsSectionContent, SettingsSectionHeader } from '../../Settings/components';
import { DisabledWrapper, LoadingSkeleton, StyledLink } from '../styles';
import { BusinessDayStart } from './sections/BusinessDayStart';
import { DaySegmentsList } from './sections/DaySegmentsList';
import { GracePeriod } from './sections/GracePeriod';
import { SuggestDaySegments } from './sections/SuggestDaySegments';

const DaySegmentsSettings = () => {
  const dispatch = useDispatch();
  const currentSite = useSelector(selectCurrentEmployeeSite);
  const daySegmentsForSite = useSelector(selectDaySegments());
  const isLoadingDaySegments = useSelector((state: IStore) => selectIsLoadingAPIRequest(state, DaySegments.GET_DAY_SEGMENTS_REQUEST));

  useEffect(() => {
    if (currentSite?.id && currentSite?.settings?.tipCalculator) {
      dispatch(getDaySegmentsRequest({ siteId: currentSite.id, options: { sort: 'created_at', limit: 0 } }));
    }
  }, [currentSite]);

  return (
    <SettingsContent data-cy="day-segments-settings-container">
      <SettingsPageHeader />

      <SettingsContentLayout>
        <SettingsSection>
          <SettingsSectionHeader>
            <H3>Day Segments</H3>
          </SettingsSectionHeader>

          <SettingsSectionContent light data-cy="day-segments-settings-form">
            <SectionTitle>Select Site</SectionTitle>
            <TipCalculatorSiteSelector />

            {!currentSite || isLoadingDaySegments ? (
              <LoadingSkeleton />
            ) : currentSite.settings?.tipCalculator ? (
              <>
                <GracePeriod currentSite={currentSite} daySegments={daySegmentsForSite?.data} />

                <BusinessDayStart currentSite={currentSite} />

                <DaySegmentsList currentSite={currentSite} daySegments={daySegmentsForSite?.data} />

                <SuggestDaySegments currentSite={currentSite} />
              </>
            ) : (
              <DisabledWrapper>
                <Text fontWeight="semibold">Tip Calculations Not Enabled</Text>
                <Text size="small">
                  {'The site selected is not enabled for tip calculations. '}
                  <StyledLink target="_blank" rel="noopener noreferrer" href={appConfig.LINKS.SUPPORT}>
                    Contact Kickfin Support
                  </StyledLink>
                  {' to learn more.'}
                </Text>
              </DisabledWrapper>
            )}
          </SettingsSectionContent>
        </SettingsSection>
      </SettingsContentLayout>
    </SettingsContent>
  );
};

export default DaySegmentsSettings;
